import _ from 'lodash'

export function resolveItemLancamentoData(data, cobertura) {
  return {
    tipo: _.get(data, 'tipo', _.get(cobertura, 'itemLancamento.tipo', null)),
    oidTipo: _.get(data, 'oidTipo', _.get(cobertura, 'itemLancamento.oidTipo', null)),
    descricao: _.get(data, 'descricao', _.get(cobertura, 'descricao', '')),
    descricaoServico: _.get(data, 'descricaoServico', _.get(cobertura, 'descricaoServico', null)),
    oidGrupo: _.get(data, 'oidGrupo', _.get(cobertura, 'oidGrupo', null)),
    entradaSaida: _.get(data, 'entradaSaida', _.get(cobertura, 'entradaSaida', null)),
  }
}

export function resolveDescricaoServicoFallback(data, cobertura) {
  return (
    _.get(cobertura, 'descricaoServico', null) ||
    _.get(data, 'descricaoServico', null) ||
    _.get(data, 'descricao', null) ||
    _.get(cobertura, 'descricao', '')
  )
}

export function buildTaxaFromContratoItem(data, cobertura) {
  const resolvedData = resolveItemLancamentoData(data, cobertura)
  return {
    itemLancamento: {
      tipo: _.get(resolvedData, 'tipo', null),
      oidTipo: _.get(resolvedData, 'oidTipo', null),
    },
    descricao: _.get(resolvedData, 'descricao', ''),
    descricaoServico: resolveDescricaoServicoFallback(resolvedData, cobertura),
    oidGrupo: _.get(resolvedData, 'oidGrupo', null),
    entradaSaida: _.get(resolvedData, 'entradaSaida', null),
    valor: _.get(cobertura, 'valor', 0),
    valorTotal: _.get(cobertura, 'quantidade', 0) * _.get(cobertura, 'valor', 0),
    quantidade: _.get(cobertura, 'quantidade', 1),
  }
}

export function resolveDescricaoServicoNFSe(descricaoServicoNFSeAtual, descricaoServicoItem) {
  if (descricaoServicoNFSeAtual && _.trim(descricaoServicoNFSeAtual).length > 0) {
    return descricaoServicoNFSeAtual
  }
  return descricaoServicoItem || descricaoServicoNFSeAtual
}
